import { Portal } from './ReactIs';
export function createPortal(children, containerInfo, key) {
    return {
        // This tag allow us to uniquely identify this as a React Portal
        $$typeof: Portal,
        key: key || '',
        children: children,
        containerInfo: containerInfo,
        implementation: null,
    };
}
